// アプリ全体の設定値。環境変数で差し替え可能なものは import.meta.env から読む。

/** Worker プロキシの base URL（§3.1 PROXY_BASE_URL）。全ての相場取得はここ経由。
 * import.meta.env は Vite 外（CLI の node 実行, §15）では未定義のため optional chaining。 */
export const PROXY_BASE_URL: string =
  import.meta.env?.VITE_PROXY_BASE_URL ?? 'http://localhost:8787';

/** 内部基準通貨（§4.1）。poe2scout の base = Exalted Orb。生の base 値は画面に出さない。 */
export const BASE_CURRENCY = 'exalted' as const;

/**
 * 表示単位・手動価格の denomination・比較の共通単位の選択肢（§4.1）。
 * 「通貨として扱われるオーブ」に限定する（exalted/chaos/divine）。
 * これらは market 行で選べるアイテム全般（§MARKET_CATEGORIES）とは別概念。
 */
export const DISPLAY_UNITS = ['divine', 'chaos', 'exalted'] as const;

/**
 * market 行（コスト・ドロップ）で選べる価格付きアイテムのカテゴリ（poe2scout の currency 系全カテゴリ）。
 * オーブだけでなく、入場券（Fragments）・素材（Essences/Runes/Soul Cores 等）も API 相場で追跡できる。
 */
export const MARKET_CATEGORIES: ReadonlyArray<{ id: string; label: string }> = [
  { id: 'currency', label: 'Currency' },
  { id: 'fragments', label: 'Fragments（入場券・断片）' },
  { id: 'essences', label: 'Essences' },
  { id: 'runes', label: 'Runes' },
  { id: 'ultimatum', label: 'Soul Cores' },
  { id: 'ritual', label: 'Ritual Omens' },
  { id: 'delirium', label: 'Delirium' },
  { id: 'breach', label: 'Breach' },
  { id: 'abyss', label: 'Abyssal Bones' },
  { id: 'expedition', label: 'Expedition' },
  { id: 'vaultkeys', label: 'Reliquary Keys' },
  { id: 'incursion', label: 'Incursion' },
  { id: 'idol', label: 'Idols' },
  { id: 'vaal', label: 'Vaal' },
  { id: 'verisium', label: 'Verisium' },
  { id: 'uncutgems', label: 'Uncut Gems' },
  { id: 'lineagesupportgems', label: 'Lineage Support Gems' },
];

/**
 * ユニークアイテムのカテゴリ（poe2scout の Uniques/ByCategory）。
 * 通貨と別エンドポイント・別レスポンス形（ApiId 無し→ `u:<UniqueItemId>` で正規化）。
 */
export const UNIQUE_CATEGORIES: ReadonlyArray<{ id: string; label: string }> = [
  { id: 'weapon', label: 'Unique 武器' },
  { id: 'armour', label: 'Unique 防具' },
  { id: 'accessory', label: 'Unique アクセサリ' },
  { id: 'jewel', label: 'Unique ジュエル' },
  { id: 'flask', label: 'Unique フラスコ' },
  { id: 'map', label: 'Unique マップ' },
  { id: 'sanctum', label: 'Sanctum' },
];

/** poe2scout Realm セグメント（PoE2）。 */
export const REALM = 'poe2' as const;

/** 実績＋予測モードの信頼度 M = 擬似周回数（§5.2 / §12.2.3）。 */
export const STRENGTH_M = { weak: 30, normal: 100, strong: 300 } as const;

/** market 行の鮮度警告しきい値（§7）。取得からこの分数を超えたら「古い可能性」。 */
export const FRESHNESS_WARN_MINUTES = 15;

/** レート推定の粗さ警告しきい値（§5.2: 観測個数 k がこれ未満なら粗い）。 */
export const ROUGH_K_THRESHOLD = 10;
